// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../v5/common/Components/IconV5.bs.js");
let Spinner = require("../../../v5/common/Components/Spinner.bs.js");
let Theme__Color = require("../../common/Theme/Theme__Color.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");
let VisuallyHidden = require("@reach/visually-hidden").default;

function SearchField(props) {
  let __rounded = props.rounded;
  let __size = props.size;
  let onChange = props.onChange;
  let __isLoading = props.isLoading;
  let isLoading = __isLoading !== undefined ? __isLoading : false;
  let size = __size !== undefined ? __size : "lg";
  let rounded = __rounded !== undefined ? __rounded : false;
  let match = size === "md" ? [
      "h-10",
      "text-base placeholder:text-base",
      16,
      "pr-3"
    ] : [
      "h-11",
      "text-lg placeholder:text-lg",
      20,
      "w-[42px] h-[42px]"
    ];
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("input", {
        className: `block flex-grow bg-white text-zinc-700 placeholder:text-zinc-500 ` + match[1] + ` px-[15px] py-2.5 leading-5 border-0 outline-none focus:outline-none appearance-none rounded-none transition-colors duration-150 m-0`,
        placeholder: props.placeholder,
        type: "search",
        value: props.value,
        onChange: e => Stdlib_Option.forEach(onChange, cb => cb(e))
      }),
      JsxRuntime.jsx("div", {
        children: isLoading ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx(Spinner.make, {
                size: 16,
                stroke: Theme__Color.toString(Theme__Color.jumbo)
              }),
              JsxRuntime.jsx(VisuallyHidden, {
                children: "Loading"
              })
            ]
          }) : JsxRuntime.jsx(IconV5.make, {
            icon: "search",
            size: match[2],
            className: "text-zinc-400"
          }),
        className: match[3] + ` border-0 flex justify-center items-center shrink-0`
      })
    ],
    className: `max-w-[500px] ` + match[0] + ` border border-zinc-300 hover:border-zinc-400 focus-within:border-tan-focused-border flex ` + (
      rounded ? "rounded overflow-hidden" : ""
    )
  });
}

let Icon;

let make = SearchField;

exports.Icon = Icon;
exports.make = make;
/* IconV5 Not a pure module */
